import React, { FormEvent, ReactElement, useEffect, useState } from "react";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  Input,
  Row,
  Select,
  Text,
} from "@jarvis-catalyst/ui-components";
import { FormSelect } from "../../styled-components/FormSelect";
import { useNavigate } from "react-router-dom";
import { useValidateForm } from "../../hooks/useValidateForm";
import { FormAlertGroup } from "../../styled-components/FormGroup";
import { keycloakServiceProvidersOptionsList } from "../../utils/listOptions";
import { FIFOptionList } from "../../config/constants";
import { useKeycloakServiceProviders } from "../../hooks/useKeycloakServiceProvider";
import { useUtils } from '../../hooks/useUtils';
import { FormProps } from '../../types';
import { hasMatchFIF } from '../../utils/sbifMatcher';

const initSelectedValue = {
  value: "",
  label: ""
  
};
const B2bOrEnterpriseAccountForm = ({hasValidPermission, onBack, isB2B, isEnterprise} : FormProps): ReactElement => {
  const navigate = useNavigate();
  const { keycloakServiceProviderUseQuery } = useKeycloakServiceProviders();
  const { error, loadingValidate, setForm, validateForm, form } = useValidateForm();
  const { setServiceProvider, setUserName } = useUtils();
  const [selectedValueProv, setSelectedValueProv] = useState(initSelectedValue);
  const [selectedValue, setSelectedValue] = useState(initSelectedValue);
  
  const handleSubmitSearchCustomer = async (event: React.FormEvent) => {
    event.preventDefault();

    if (validateForm()) {
      return;
    }
    
    setServiceProvider(form.serviceProvider);
    hasMatchFIF(form.serviceProvider) ? setUserName(form.nroDocumento) : setUserName(form.email);

    navigate("/validateConsent/profileConsent", {
      state: {
        form,
        isB2B,
        isEnterprise
      }
    });
  };

  useEffect(() => {
    setForm({ ...form, isB2B, isEnterprise });
  }, [false]);

  return (
    <>
      <Row className="d-flex justify-content-center align-items-center">
        <Col md={8} lg={6} xs={12}>
          <Card className="shadow">
            <CardBody>
              <div className="mb-3 mt-md-4">
                <h2 className="fw-bold mb-2 text-uppercase text-center">Validate User & Consents</h2>
                <hr />
                <form className="mb-1" onSubmit={handleSubmitSearchCustomer}>
                  <div className="">
                    <Text>Service Provider:</Text>
                    <Select
                      onInputChange={(value: string) => setForm({ ...form, serviceProvider: value })}
                      options={keycloakServiceProvidersOptionsList(keycloakServiceProviderUseQuery.data)}
                      onSelectedValue={setSelectedValueProv}
                      value={selectedValueProv}
                      placeholder="Select an option..."
                      textNotFound="-- Not Found --"
                    />
                  </div>
                  {form.serviceProvider && (
                    <>
                    <FormSelect>
                      <Text>Document type:</Text>
                      <Select
                        onInputChange={(value: string) => setForm({ ...form, tipoDocumento: value })}
                        options={FIFOptionList}
                        onSelectedValue={setSelectedValue}
                        value={selectedValue}
                        placeholder="Select an option..."
                        textNotFound="-- Not Found --"
                      />
                    </FormSelect>
                    <div className="mb-3">
                      <Text>Document number:</Text>
                      <Input
                        placeholder={"12345678-9 or 123456789"}
                        value={form.nroDocumento}
                        onChange={(e: FormEvent<HTMLInputElement>) => {
                          setForm({ ...form, nroDocumento: e.currentTarget.value });
                        }}
                      />
                    </div>
                    </>
                  )}

                  {!hasMatchFIF(form.serviceProvider) && form.serviceProvider && (
                    <>
                    <div className="mb-3">
                      <Text className="">Email:</Text>
                      <Input
                        focus
                        placeholder={"email@example.com"}
                        value={form.email}
                        onChange={(e: FormEvent<HTMLInputElement>) => {
                          setForm({ ...form, email: e.currentTarget.value });
                        }}
                      />
                    </div>
                    </>
                  )}
                  <br></br>
                  <div className="d-grid">
                    <Button color="primary" className="mt-2 text-center" disabled={!hasValidPermission}>
                      Check User
                    </Button>
                    <Button
                      disabled={loadingValidate}
                      color="bordered"
                      type="button"
                      className="mt-2 text-center"
                      onClick={onBack}
                    >
                      Back
                    </Button>
                  </div>
                </form>
              </div>
            </CardBody>
            {error.message && (
              <CardFooter>
                {error.message && (
                  <FormAlertGroup className="text-center">
                    <Alert color="danger">{error.message}</Alert>
                  </FormAlertGroup>
                )}
              </CardFooter>
            )}
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default B2bOrEnterpriseAccountForm;
